import { faBook } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useCallback, type FC } from 'react'

import { useAvailableDocumentAnalysisModes } from 'hooks/useAvailableDocumentAnalysisModes'
import { useTriggerEvent } from 'hooks/useTriggerEvent'
import { useTranslation } from 'services/i18n'
import { useClosePanel } from 'stores/usePanelsStateStore'
import { useIsXlOrAbove } from 'stores/useScreenSizeStore'

import { ConversationsHistoryLink } from './ConversationsHistoryLink'

export const NewDocumentAnalysisButton: FC = () => {
  const { t } = useTranslation()

  const { availableDocumentAnalysisModes } = useAvailableDocumentAnalysisModes()

  const triggerEvent = useTriggerEvent()

  const isXlOrAbove = useIsXlOrAbove()

  const closePanel = useClosePanel()

  const handleClick = useCallback(() => {
    triggerEvent({
      name: 'kai_new_document_analysis_button_clicked',
    })

    if (!isXlOrAbove) closePanel('conversations_menu')
  }, [closePanel, isXlOrAbove, triggerEvent])

  if (!availableDocumentAnalysisModes.length) return null

  return (
    <ConversationsHistoryLink
      url="/document_analysis"
      icon={<FontAwesomeIcon icon={faBook} />}
      tooltipContent={t('conversation_history.new_document_analysis_button')}
      onClick={handleClick}
      title={t('conversation_history.new_document_analysis_button')}
      titleShort={t('conversation_history.new_document_analysis_button_short')}
    />
  )
}
